import { newSize, newTextPinComponent, newVector, fallbackCopy } from '../helpers';
import { QuizPinLayoutTemplate } from '../models';
import { stringToProsemirror } from '../tip-tap';

export function quizTitleOnlyLayout({
  question = fallbackCopy['quiz.title'],
  backgroundColor,
  backgroundImage,
}: {
  question?: string;
  backgroundColor?: string;
  backgroundImage?: string;
} = {}): QuizPinLayoutTemplate {
  return {
    key: 'TITLE_ONLY',
    backgroundColor,
    backgroundImage,
    layoutParts: {
      TITLE: newTextPinComponent({
        position: newVector(32, 32),
        size: newSize(896, 60),
        content: stringToProsemirror(question, {
          bold: true,
        }),
        order: 'a0',
        settings: {
          textStyleKey: 'TITLE',
          typographyKey: 'headline',
          horizontalAlignment: 'center',
        },
      }),
    },
    pinComponents: [],
  };
}
